var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 408C512 412.406 508.406 416 504 416H416V504C416 508.406 412.406 512 408 512S400 508.406 400 504V123.312L123.313 400H344C348.406 400 352 403.594 352 408S348.406 416 344 416H104C99.594 416 96 412.406 96 408V112H8C3.594 112 0 108.406 0 104S3.594 96 8 96H96V8C96 3.594 99.594 0 104 0S112 3.594 112 8V388.688L388.688 112H168C163.594 112 160 108.406 160 104S163.594 96 168 96H404.688L474.344 26.344C477.469 23.219 482.531 23.219 485.656 26.344S488.781 34.531 485.656 37.656L416 107.312V400H504C508.406 400 512 403.594 512 408Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.feefe5aa8ed793c748700ffbf91ad1ae.svg";
export { ForwardRef as ReactComponent };